import { render, staticRenderFns } from "./LocalizationSummary.vue?vue&type=template&id=f05ca7e2&scoped=true&"
import script from "./LocalizationSummary.vue?vue&type=script&lang=js&"
export * from "./LocalizationSummary.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationSummary.vue?vue&type=style&index=0&id=f05ca7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ca7e2",
  null
  
)

export default component.exports